
import * as yup from 'yup';
import ValidationMessage from '../../constants/Validation/ValidationMessage';
import ValidationMessageAlbanian from '../../constants/Validation/ValidationMessageChange';



const AddNewServiceValidation = (serviceIds: any) => {
    const local_language = localStorage.getItem('lang')

    const schemaObject = serviceIds.reduce((accumulator: any, serviceId: any) => {
        accumulator[`name_${serviceId}`] = yup.string()
            .required(local_language == "alb" ? ValidationMessageAlbanian.Field("emri i shërbimit") : ValidationMessage.Field('service name'))
            .min(3, local_language == "alb" ? ValidationMessageAlbanian.MinLength('emri i shërbimit', 3) : ValidationMessage.MinLength('service name', 3)),


            accumulator[`price_${serviceId}`] = yup
            .string()
            .required(local_language == "alb" ? ValidationMessageAlbanian.Field("çmimi i shërbimit") : ValidationMessage.Field("service price"))
            .min(2, local_language == "alb" ? "Çmimi i shërbimit duhet të jetë të paktën 3 shifror" : "Service price must be at least 2 digits.")
            .matches(/^[1-9][0-9]{0,4}$/, 'Ju lutemi vendosni një çmim të vlefshëm me deri në 5 shifra')
            .test('min-value', 'Vlera minimale duhet të jetë së paku 2 shifrore.', value => parseInt(value, 10) >= 2),
            // accumulator[`price_${serviceId}`] = yup
            //     .string()
            //     .required(local_language == "alb" ? ValidationMessageAlbanian.Field("çmimi i shërbimit") : ValidationMessage.Field("service price"))
            //     .matches(/^[1-9][0-9]{0,4}$/, 'Ju lutemi vendosni një çmim të vlefshëm me deri në 5 shifra')
            //     .test('min-value', 'Vlera minimale duhet të jetë së paku 2 shifrore.', value => parseInt(value, 10) >= 3),

            accumulator[`duration_${serviceId}`] = yup.string().required(local_language == "alb" ? 'Ju lutemi zgjidhni kohëzgjatjen e shërbimit' : "Please select duration."),

            accumulator[`description_${serviceId}`] = yup.string()
                .required(local_language == "alb" ? ValidationMessageAlbanian.Field("përshkrimi i shërbimit") : ValidationMessage.Field('service description.'))
                .max(300, local_language == "alb" ? ValidationMessageAlbanian.MaxLength('përshkrim', 300) : ValidationMessage.MaxLength('description', 300)),

            accumulator[`selectedStaffMembers_${serviceId}`] = yup.array()
                .min(1, local_language == "alb" ? 'Asnjë anëtar i stafit nuk është shtuar ende.' : "No staff member added yet.")
                .required(local_language == "alb" ? 'Asnjë anëtar i stafit nuk është shtuar ende.' : "No staff member added yet.");
        return accumulator;
    }, {});
    return yup.object().shape(schemaObject);
};

export default AddNewServiceValidation;
